import { SettingsService, Menu } from './../../core/services/settings.service';
import { Component, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import {
  Router, RouteConfigLoadStart, NavigationCancel, NavigationError,
  NavigationEnd
} from '@angular/router';
import { fromEvent } from 'rxjs';

import { _HttpClient } from 'src/app/core/net/http.client';
import { ApiService } from 'src/app/core/net/apiRoute';
import { debounceTime } from 'rxjs/operators';
import { ResponseContext } from 'src/app/core/net/response-context.interface';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
 
@Component({
  selector: 'app-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.less']
})
 

export class HomeLayoutComponent implements OnInit {
  isFetching = false;
  isDown: boolean = false;
  disX = 0;
  disY = 0;


  constructor(private el: ElementRef, router: Router, public settings: SettingsService, public _message: NzMessageService, public http: _HttpClient) {
    router.events.pipe().subscribe(evt => {
      if (!this.isFetching && evt instanceof RouteConfigLoadStart) {
        this.isFetching = true;
      }
      if (evt instanceof NavigationError || evt instanceof NavigationCancel) {
        this.isFetching = false;
        if (evt instanceof NavigationError) {
          _message.error(`无法加载${evt.url}路由`, { nzDuration: 1000 * 3 });
        }
        return;
      }
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      setTimeout(() => {
        // scroll.scrollToTop();
         this.isFetching = false;
      }, 500);
    });
  }
  ngOnInit(): void {
    this.setLayoutStyle();
    fromEvent(window, 'resize')
      .pipe(debounceTime(500))
      .subscribe(() => this.setLayoutStyle());
    if (!this.settings.firstLogin) {
      this.http.get(ApiService.GetMenu, {
        userId: this.settings.user.userId
      })
        .subscribe((res: ResponseContext<Menu>) => {
          if (res.Status !== 1) {
            this._message.error(`请求错误${res.Message}路由`, { nzDuration: 1000 * 3 });
            return;
          }
          this.settings.setMenu(res.Result);
        });
    } else {

      this.settings.firstLogin = false;
    }

  }

  setLayoutStyle() {
    if (this.settings.isReduce) {
      this.settings.setLayout('collapsed', true);

    } else {
      this.settings.setLayout('collapsed', false);
    }
    if (!this.settings.isReduce || !this.settings.layout.collapsed) {
      this.settings.layout.collapsedWidth = 80;
    } else {
      this.settings.layout.collapsedWidth = 0;
    }
  }

  onMenuItemClick() {
    if (this.settings.layout.collapsedWidth == 0) {
      this.settings.setLayout('collapsed', true);
    }
  }
  toggle() {

    this.settings.setMessageBox("show", !this.settings.messageBox.show);
  }
  imMax() {
    var dv = this.el.nativeElement.querySelector('.messageContext');
    if (this.settings.messageBox.max) {

      dv.style.left = "0px";
      dv.style.top = "0px";
      dv.style.bottom = 'auto';
      dv.style.right = 'auto';
      dv.style.width = document.body.offsetWidth + "px";
      dv.style.height = document.body.offsetHeight + "px";
      this.settings.setMessageBox("left", "0px");
      this.settings.setMessageBox("top", "0px");
      this.settings.setMessageBox("bottom", "auto");
      this.settings.setMessageBox("right", "auto");
      this.settings.setMessageBox("width", document.body.offsetWidth+'px');
      this.settings.setMessageBox("height", document.body.offsetHeight+'px');
    } else {
      var dv = this.el.nativeElement.querySelector('.messageContext');
      this.settings.setMessageBox("width", this.settings.messageBox.lastWidth);
      this.settings.setMessageBox("height", this.settings.messageBox.lastHeight);

      this.settings.setMessageBox("left", this.settings.messageBox.lastLeft);
      this.settings.setMessageBox("top", this.settings.messageBox.lastTop);
      this.settings.setMessageBox("bottom", this.settings.messageBox.lastBottom);
      this.settings.setMessageBox("right", this.settings.messageBox.lastRight);
    }
  }

  onImChange(e) {
    if (e.type == "max") {
      this.imMax();
    }
  }

  animationFrameId = -1;
  onResize({ width, height }: NzResizeEvent): void {
    cancelAnimationFrame(this.animationFrameId);
    this.animationFrameId = requestAnimationFrame(() => {

      this.settings.setMessageBox("width", width+'px');
      this.settings.setMessageBox("height", height+'px');
      this.settings.setMessageBox("lastWidth", width+'px');
      this.settings.setMessageBox("lastHeight", height+'px');
    });
  }

}
